import { createAstraSatinClient } from "./astraSatinClient";
export const createAutoSatinWorker = createAstraSatinClient;
